import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  paid: () => __(translations.orderCellsFeatures.paid, 'Paid'),
  overpaid: () => __(translations.orderCellsFeatures.overpaid, 'Overpaid'),
};
